import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';

import ImageSelector from '../ImageSelector';

import './index.css';

class Identification extends React.Component {
  constructor(props) {
    super(props);
    this.imageref = React.createRef();
    this.state = {};
  }

  getMinPoints() {
    return this.props.minPoints ? this.props.minPoints : 100;
  }

  identified() {
    return (
      Object.keys(this.props.identity ? this.props.identity : {}).reduce(
        (acc, val) => acc + this.props.documents[val].points,
        0
      ) >= this.getMinPoints()
    );
  }

  render() {
    return (
      <div className="identification">
        <h4>Please provide another document for {this.getMinPoints()} points</h4>
        {this.props.identity ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Document Type</TableCell>
                <TableCell>Points</TableCell>
                <TableCell>Document</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(this.props.identity).map((k) => (
                <TableRow
                  key={k}
                  onClick={() =>
                    this.setState({
                      ...this.state,
                      dialog: 'delete',
                      deletekey: k
                    })
                  }>
                  <TableCell>{this.props.documents[k].name}</TableCell>
                  <TableCell>{this.props.documents[k].points}</TableCell>
                  <TableCell>
                    <img src={this.props.identity[k].image.contents} alt={k} className="doc" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : null}
        {!this.props.identity ||
        Object.keys(this.props.identity).reduce(
          (acc, val) => acc + this.props.documents[val].points,
          0
        ) < this.getMinPoints() ? (
          <>
            <div className="docform">
              <FormControl>
                <InputLabel id="doclabel">Document</InputLabel>
                <Select
                  labelId="doclabel"
                  value={this.state && this.state.doctype ? this.state.doctype : ''}
                  onClick={(e) => {
                    if (e.target.value !== 0) {
                      this.setState({ ...this.state, doctype: e.target.value });
                    }

                    this.imageref.current.click();
                  }}>
                  {Object.keys(this.props.documents)
                    .filter((document) => !this.props.identity || !this.props.identity[document])
                    .filter(
                      (document) =>
                        !this.props.excludeOpts || this.props.excludeOpts.indexOf(document) < 0
                    )
                    .map((document) => (
                      <MenuItem key={document} value={document}>
                        {this.props.documents[document].name} (
                        {this.props.documents[document].points} Points)
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>

            <ImageSelector
              style={{ display: 'none' }}
              ref={this.imageref}
              acceptAll
              value={this.props.image ? this.props.image : null}
              height={128}
              width={128}
              max_filesize={5242880}
              onChange={(e) => {
                if (e) {
                  this.props.onChange(
                    {
                      identity: {
                        ...(this.props.identity ? this.props.identity : {}),
                        [this.state.doctype]: { image: e }
                      }
                    },
                    () => {
                      this.setState(
                        {
                          doctype: null,
                          image: ''
                        },
                        () => {
                          if (this.imageref.current) this.imageref.current.clear();
                          this.props.onChange({
                            identified: this.identified()
                          });
                        }
                      );
                    }
                  );
                }
              }}
              onError={(e) => {
                this.setState({ ...this.state, dialog: 'error' });
              }}
            />
          </>
        ) : (
          ''
        )}

        <Dialog
          open={this.state && this.state.dialog === 'error'}
          onClose={() => this.setState({ ...this.state, dialog: null })}>
          <DialogTitle>Error</DialogTitle>

          <DialogContent>
            An error has occured when uploading the selected file, this can happen when:
            <p>The selected file exceeds the maximum size of 5mb</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ ...this.state, dialog: null })}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state && this.state.dialog === 'delete' ? true : false}
          onClose={() => this.setState({ ...this.state, dialog: null })}>
          <DialogTitle>Delete {this.state && this.state.deletekey}?</DialogTitle>
          <DialogContent>
            {this.state && this.state.deletekey ? (
              <DialogContentText className="delete-dialog">
                <img
                  src={this.props.identity[this.state.deletekey].image.contents}
                  alt={this.state.deletekey}
                />
                Do you wish to delete the image you uploaded as{' '}
                {this.state ? this.state.deletekey : ''}?
              </DialogContentText>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ ...this.state, dialog: null })}>Close</Button>
            <Button
              onClick={() => {
                const identity = (({ [this.state.deletekey]: _, ...identity }) => identity)(
                  this.props.identity
                );
                this.setState({
                  dialog: null,
                  deletekey: null
                });
                this.props.onChange(
                  {
                    identity: identity
                  },
                  () => {
                    this.props.onChange({
                      identified: this.identified()
                    });
                  }
                );
              }}
              variant="contained"
              color="primary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Identification;
